<script setup lang="ts">
import type { Product } from '~/config'

interface Props {
  product: Product
  formLink: string
  whatsAppLink?: string
}

const props = defineProps<Props>()

const backgroundStyle = computed(() => ({
  backgroundImage: props.product?.bannerFile
    ? `url(/siteAssets/img|product-cards/${props.product.bannerFile})`
    : undefined,
}))
</script>

<template>
  <div
    class="relative flex aspect-[16/8] w-full items-end bg-cover bg-center md:aspect-[16/6]"
    :style="backgroundStyle"
  >
    <div class="absolute right-0 top-0 z-10">
      <slot name="action" />
    </div>

    <div class="absolute inset-0 z-0 bg-primary-950/30" />

    <!-- FIX: z-1 → z-10 -->
    <div class="relative z-10 flex flex-col gap-2 p-2 md:p-8">
      <div class="flex items-center gap-2 lg:gap-4">
        <ImageComponent
          :src="`/siteAssets/img|product-icons/${product.iconFile}`"
          :alt="product?.name"
          class="size-10 rounded-md md:size-20"
        />
        <span class="text-surface text-2xl lg:text-6xl font-bold uppercase md:text-5xl">
          Seguro de {{ product?.alias ?? product?.name }}
        </span>
      </div>

      <div class="flex gap-2">
        <PvButton
          as="a"
          @click="navigateTo(formLink, { external: true })"
        >
          <span class="text-sm md:text-base">Comprar</span>
        </PvButton>

        <PvButton
          v-if="whatsAppLink"
          plain
          as="a"
          class="whatsapp bg-[#009688]"
          :href="whatsAppLink"
          target="_blank"
        >
          <div class="flex items-center gap-2">
            <span class="icon-[mdi--whatsapp] text-xl" />
            <span class="hidden md:inline">Chatea con un agente</span>
          </div>
        </PvButton>
      </div>
    </div>
  </div>
</template>
